module.exports = __webpack_public_path__ + "fonts/KFhimaji.4a8885e0.ttf";